import React from 'react'
import { getArticlesRelated, getEventsRelated, getProjectsRelated } from '../../utils/api'
import ArticleCard from '../elements/article-card'
import Divider from '../elements/divider'
import EventCard from '../elements/event-card'
import ProjectCard from '../elements/project-card'

import ScrollTrigger from "gsap/dist/ScrollTrigger"
import gsap from "gsap"
import CustomLink from '../elements/custom-link'

const RelatedSection = ({data, fields, pageContext}) => {
    const [activeFilter, setActiveFilter] = React.useState("all");
    const [currentPage, setCurrentPage] = React.useState(1);
    const [gridData, setGridData] = React.useState(null);


    // const onClickFilterHander = (tag) => {
    //     if(!tag){
    //         setActiveFilter("all");
    //         getData("all").then(()=>{
    //             ScrollTrigger.refresh();
    //             ScrollTrigger.update();
    //           });;
    //     }else{
    //         setActiveFilter(tag);
    //         getData(tag).then(()=>{
    //             ScrollTrigger.refresh();
    //             ScrollTrigger.update();
    //           });;
    //     }

    // }
    const getData = async (tag) => {
        let res = null;
        switch(pageContext.pageType){
            case "projects":
                res = await getProjectsRelated("", pageContext.locale, false, pageContext.date, currentPage, 2, pageContext.slug, pageContext.time);
                break;
            case "events":
                res = await getEventsRelated("", pageContext.locale, false, pageContext.date, currentPage, 4, pageContext.slug, pageContext.time);
                break;
            case "articles":
                res = await getArticlesRelated("", pageContext.locale, false, pageContext.date, currentPage, 4, pageContext.slug, pageContext.time);
                break;
        }

        // console.log(res);
        setGridData(res)
    }
    React.useEffect(()=>{
        getData(activeFilter).then(()=>{
            ScrollTrigger.refresh();
            ScrollTrigger.update();
        });;
    },[])

    const renderCards = () => {
        let res = null;
        switch(pageContext.pageType){
            case "projects":
                res = (
                <div className="grid gap-0 py-12 align-top md:grid-cols-2">
                    {gridData && gridData.map((project, index) => (
                        <ProjectCard event={project} key={index} isFilterSection={true}/>
                    ))}
                </div>
                )
                break;
            case "events":
                res = (
                <div className="grid grid-cols-2 gap-5 py-12 align-top md:grid-cols-4 md:gap-0 margin-fix-cards">
                    {gridData && gridData.map((project, index) => (
                        <EventCard event={project} key={index} isFilterSection={true}/>
                    ))}
                </div>
                )
                break;
            case "articles":
                res = (
                <div className="grid grid-cols-2 gap-5 py-12 align-top md:grid-cols-4 md:gap-0 margin-fix-cards">
                    {gridData && gridData.map((project, index) => (
                        <ArticleCard event={project} key={index} isFilterSection={true}/>
                    ))}
                </div>
                )
                break;
        }

        return res;
    }

    function isPt(){
        return pageContext.locale == "pt-PT" || pageContext.locale == "pt";
    }

    function renderName(){
        switch(pageContext.pageType){
            case "projects":
                return isPt() ? "Outros Projetos" : "Other Projects"
            case "events":
                return isPt() ? "Outros Eventos" : "Other Events"
            case "articles":
                return isPt() ? "Outros Notícias" : "Other News"
            default:
                return isPt() ? "Outros Projetos" : "Other"
        }
    }

    function renderLink(){
       return isPt() ? "Ver Todos" : "See All"
    }

  return (
    
    <div className="container w-full mt-20 mb-40">
        <div>
            {/* <Divider/>
            <div className="" style={{fontSize:"20px", maxWidth:"60ch"}}>
                <h3 className="my-6 mt-2 font-bold" style={{fontSize:"20px", maxWidth:"30ch"}}>{renderName()}</h3>
            </div> */}
            <Divider />
            <div className="flex justify-between my-4">
            <h2 className="font-bold">{renderName()}</h2>
            <CustomLink link={{ url:`/${pageContext.pageType}`, newTab:false}}>
                <div className='p-1 px-10 text-center text-black' style={{
                    maxWidth:"263px",
                    background: "transparent 0% 0% no-repeat padding-box",
                    border: "1px solid #000000",
                    borderRadius: "22px",
                    fontSize:"14px"
                }}>{renderLink()}</div>
            </CustomLink>
            </div>
        </div>
        <div className="">
            <div className="flex flex-wrap mt-10">
                {/* {fields.map((field, index) => {
                    return (
                    <div key={index} onClick={(e)=>{onClickFilterHander(field.tag)}}
                        className={`flex flex-wrap items-center justify-center text-center text-md md:text-sm button my-5 dark outline-cm mr-8 ${activeFilter === field.tag ? "active" : ""}`}
                        style={{fontSize:"20px", "--color1-var": field.color1, "--color2-var": field.color2, "--text-hover":"#000"}}>{field.name}</div>
                    )
                })} */}
                {/* <div onClick={(e)=>{onClickFilterHander()}} className={`flex flex-wrap items-center justify-center text-center text-md md:text-sm button my-5 dark outline-cm mr-8 ${activeFilter === "all" ? "active" : ""}`} style={{fontSize:"20px"}}>Todos</div> */}
            </div>
        </div>
        <div>
            {renderCards()}
        </div>
    </div>
  )
}

export default RelatedSection

// #6B514A
// #F55C30
// #1BBEAF